import React, { Component } from 'react';
import { compose, withState, lifecycle, withHandlers } from 'recompose';
import Iframe from 'react-iframe';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';

import Popup from '../Popup';
import { commonStyles, COLORS } from '../../styles/styles';
import { STATUSES, STORAGE_LINK, STORAGE_LINK2, APP_LINK } from '../../constants';
import { statusCode } from '../../utils';
import IframeComm from 'react-iframe-comm';
import {
  selectAssessment, selectUserContent, getUserProgramsFullRequest, selectAssessmentContent, selectRollout, setCost, selectUserModule, toggleExamComplete, submitMCQ, selectItem,
  selectAttempt
} from '../../redux/reducers/userProgramsFull';
import {
  saveTimeTaken,
  addComponentStatusRequest,
  saveStatus,
} from '../../redux/reducers/addComponentStatus';

import {
  assignmentRequestRequest, setMediaType
} from '../../redux/reducers/assignmentRequest';

import PDFTron from '../PDFTron';

import split from '../../assets/split.svg';

import {
  saveAnnotationRequest,
  saveBookmarksRequest,
  selectAnnotationSave,
  selectBookmarksSave
} from '../../redux/reducers/annotations';

import { selectedModule, selectedContent, selectedModuleId, selectedProgramId } from '../../redux/selectors';

import {Rnd} from 'react-rnd'
import { MDBIcon } from 'mdbreact';
import { printReportFailure } from '../../redux/reducers/savedVersions';
import { setDeleteIndex, setPopUps, showSaveModal } from '../../redux/reducers/view';
import { xapiRequest } from '../../redux/reducers/xapi';
import { contentItemRequest } from '../../redux/reducers/contentList';
import ExamTimer from '../ExamTimer';
import { loginReducer } from '../../redux/reducers/login';
import { getProctoringExamDayWarningState } from '../../utils/proctoringExamTimes';
import { CookiesProvider, Cookies } from 'react-cookie';
const cookies = new Cookies();

var sha1 = require('sha1');
class ZoomPopup extends Component {
 
constructor(props){
  super(props)
  
  this.refObj = {}
  this.refObj[props.zDepth] = React.createRef()
}

render(){
  const {
    selectedContent: { type: contentType },
    classes,
    handlePopupToggle,
    pathToIframeFile,
    selectedContent,
    handleMessage,
    handlePauseVideo,
    saveStatus,
    handleUpdateStatus,
    handlePDFTRONSENDMessage,
    user,
    submitMCQ,
    getUserComponent,
    viewAssignment,
    selectedAttempt,
    getHTMLPath,
    selectUserContent,
    handlePDFTRONMessage,
    logbookImage,
    handleMinimize,
    minimized,
    saveTimeTaken,
    addComponentStatusRequest,
    getUserProgramsFullRequest,
    zDepth,
    onDrag,
    onDragStart,
    onDragStop,
    setDeleteIndex,
    isMobile,
    isDragged,
    submitMCQRequest

  } = this.props;

  const getParameterByName = (name) => {
    var queryStringFromStartOfValue = window.location.search.split(name + '=')[1];
    return queryStringFromStartOfValue !== undefined ? queryStringFromStartOfValue.split('&')[0] : null;
    }

  const postMessageData = {msg:'LOGBOOKIMAGE',img:logbookImage};
  try {
    var checksum = sha1('joinfullName='+escape(user.user.firstName+' '+user.user.lastName)+'&meetingID='+selectedContent.meeting_id+'&password='+selectedContent.password+'&redirect=truey0wiq50aUjh5Un9cFR0ewUl9Xog9uPXrJMQJCK80Pw')
  } catch (error) {
    
  }
  var exam = 0;
  if(selectedContent.survey_exam==true || selectedContent.survey_supplementary==true){
    exam=1;
  }
  const proctorWarn =
    exam === 1 && user && user.user
      ? getProctoringExamDayWarningState(
          user.user,
          this.props.programsFull,
          selectedContent.survey_id
        )
      : { show: false };
  const refObj = {};
  {}
  return (
    <Popup style={{height:'100%', width:'100%', }} zDepth={selectedContent.type=='Webinar' ? 900 : 1000-zDepth} index={zDepth}>
      {proctorWarn.show && (
        <div
          role="alert"
          style={{
            background: '#fff3cd',
            color: '#856404',
            padding: '12px 16px',
            fontSize: 14,
            lineHeight: 1.4,
            borderBottom: '1px solid #ffc107',
          }}
        >
          {proctorWarn.message}
        </div>
      )}

   <Rnd
        ref={c => { this.rnd = c; }}
        default={{
          x: 0,
          y: 0,
          width: '100%',
          height: '100%',
        }}
        style={{ zIndex: 999, pointerEvents: 'all' }}
        minWidth={200}
        minHeight={50}
        onDrag={onDrag}
        bounds="parent">
      <div className="popupHolder">
        <div className="iframePopup">
        
        <div className={classes.popupHeader}>
          <div style={{position:'absolute', left:0, top:10}}>
          {!minimized ? <h6 className='text-white text-left pl-3 pb-2'>
                {String(selectedContent.name).substring(0, 30)+'...'}
              </h6> :  <h6 className='text-white text-left pl-3 pb-2'>
                {String(selectedContent.name).substring(0, 20)+'...'}
              </h6>
          } 
          </div>
    
         
         
        {!minimized ? <MDBIcon onTouchStart={() => {
          let elem =  document.querySelector('#popup-container')
          let rect = elem.getBoundingClientRect();

          this.rnd.updateSize({ width: 300, height: 210 });

          if(isDragged==false){
           
           this.rnd.updatePosition({ x: (rect.right-(330*(zDepth+1))), y: rect.bottom-300 });
          }else{
           
           this.rnd.updatePosition({ x: isDragged.xPos, y: isDragged.yPos });
          }

          handleMinimize();
        }} id='minIcon' icon="window-minimize" style={{height:20, cursor:'pointer'}} className={classes.closePopup} onClick={() => {
          let elem =  document.querySelector('#popup-container')
          let rect = elem.getBoundingClientRect();

          this.rnd.updateSize({ width: 300, height: 210 });

          if(isDragged==false){
           
           this.rnd.updatePosition({ x: (rect.right-(330*(zDepth+1))), y: rect.bottom-300 });
          }else{
           
           this.rnd.updatePosition({ x: isDragged.xPos, y: isDragged.yPos });
          }

          handleMinimize();
        }}/> :
              <MDBIcon icon="window-maximize" style={{height:20}} className={classes.closePopup} onTouchStart={() => {
                let elem =  document.querySelector('#popup-container')
                let rect = elem.getBoundingClientRect();
                       
                     this.rnd.updateSize({ width: '100%', height: '100%' });
                    
                     this.rnd.updatePosition({ x: 0, y: 0 });
                     handleMinimize();
                    }} onClick={() => {
                let elem =  document.querySelector('#popup-container')
                let rect = elem.getBoundingClientRect();
                       
                     this.rnd.updateSize({ width: '100%', height: '100%' });
                    
                     this.rnd.updatePosition({ x: 0, y: 0 });
                     handleMinimize();
                    }}/>}
            <Clear
              className={classes.closePopup}
              onTouchStart = {() => {
               
                selectUserContent(selectedContent.contentId)
                if (selectedContent) {
                  if(selectedContent.type=='Document'){
                    handlePDFTRONSENDMessage(selectedContent, this)
                  }else if (Object.keys(selectedContent).length > 1) {
                    setDeleteIndex(zDepth)
                    handlePopupToggle(selectedContent, true);
                  } else {
                    setDeleteIndex(zDepth)
                    handlePopupToggle(false, true);
                  }
                  if (
                    saveStatus &&
                    (contentType === 'Image' ||
                      contentType === 'jpg' ||
                      contentType === 'png' ||
                      contentType === 'Document' ||
                      contentType === 'HTML Captivate' ||
                      contentType === 'HTML Articlulate')
                  ) {
                    
                    saveStatus(STATUSES.completed.value);
                  }
                  if(selectedContent.type=='Webinar' && selectedContent.mediaUrl==null){
                    saveStatus(STATUSES.completed.value);
                  }
                  if (contentType!='Assignments' && contentType!='Survey' && contentType!='WSR Assessments') {
                    
                   //saveTimeTaken(Math.round((Date.now() - startTimePdf) / 1000));
                    //addComponentStatusRequest();
                  }else{
                    
                  }
                }
              
                getUserComponent()
              }}
            
              onClick={() => {
                selectUserContent(selectedContent.contentId)
                if (selectedContent) {
                  if(selectedContent.type=='Document'){
                    handlePDFTRONSENDMessage(selectedContent, this)
                  }else if (Object.keys(selectedContent).length > 1) {
                    setDeleteIndex(zDepth)
                    handlePopupToggle(selectedContent, true);
                  } else {
                    setDeleteIndex(zDepth)
                    handlePopupToggle(false, true);
                  }
                  if (
                    saveStatus &&
                    (contentType === 'Image' ||
                      contentType === 'jpg' ||
                      contentType === 'png' ||
                      contentType === 'Document' ||
                      contentType === 'HTML Captivate' ||
                      contentType === 'HTML Articlulate')
                  ) {
                    
                    saveStatus(STATUSES.completed.value);
                  }

                  if(selectedContent.type=='Webinar' && selectedContent.mediaUrl==null){
                    saveStatus(STATUSES.completed.value);
                  }
                  if (contentType!='Assignments' && contentType!='Survey' && contentType!='WSR Assessments') {
                    
                   //saveTimeTaken(Math.round((Date.now() - startTimePdf) / 1000));
                    //addComponentStatusRequest();
                  }else{
                    
                  }
                }

                getUserComponent()
              }}
            />
           
          </div>
          <div className={classes.iframeContainer}>

            {(selectedContent.type === 'Webinar'  && selectedContent.mediaUrl==null) && (
              
               <IframeComm attributes={ { allow:"camera;microphone",src: 'https://bbb.cpslearn.co.za/bigbluebutton/api/join?fullName='+escape(user.user.firstName+' '+user.user.lastName)+'&meetingID='+selectedContent.meeting_id+'&password='+selectedContent.password+'&redirect=true&checksum='+checksum,
               width: "100%",
               height: "100%",
            }}
            
         handleReceiveMessage={handleMessage} />
           )
          }
            {(selectedContent.type === 'Webinar'  && selectedContent.mediaUrl!=null) && (
                 <IframeComm attributes={ { allow:"camera;microphone",src: selectedContent.mediaUrl,
                 width: "100%",
                 height: "100%",
              }}
              
           handleReceiveMessage={handleMessage} />
            )}
            {(selectedContent.type === 'Assignments' && submitMCQ) && (
               (<IframeComm attributes={ {src: APP_LINK+'survey/surveyview_js.html?loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=1'+'&logbook=0&exam='+exam,
               width: "100%",
               height: "100%",
            }}
            
         handleReceiveMessage={handleMessage} />)
             // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
              //  <Iframe className={classes.iframePopup} url={process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0' }/>
              )}
            {(selectedContent.type === 'Form Builder') && (
               <IframeComm attributes={ {src: APP_LINK+'surveygenerator/?aiEnabled='+selectedContent.aiEnabled+'&loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&attempt=1&adminName='+user.user.admin+'&type_id=15&standalone=true&pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&logbook=0&exam='+exam,
               width: "100%",
               height: "100%",
            }}
            
         handleReceiveMessage={handleMessage} />
              )}



            {(selectedContent.type === 'Assessment Builder') && viewAssignment && (
               <IframeComm attributes={ {src: APP_LINK+'surveygenerator/?aiEnabled='+selectedContent.aiEnabled+'&loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&type_id=14&standalone=true&readOnly=1&attempt='+(selectedAttempt ? selectedAttempt+'&readOnly=1&editable=0' : (selectedContent.attempts.length+1+'&editable=1'))+'&pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate='+ (submitMCQ ? 1 : 0) +'&logbook=0&exam='+exam,
               width: "100%",
               height: "100%",
            }}
            
         handleReceiveMessage={handleMessage} />
              )}
            {(selectedContent.type === 'Assessment Builder') && !viewAssignment && (
             <IframeComm attributes={ {src: APP_LINK+'surveygenerator/?aiEnabled='+selectedContent.aiEnabled+'&loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&type_id=14&standalone=true&pid=web0&attempt='+(selectedAttempt ? selectedAttempt+'&readOnly=1&editable=0' : (selectedContent.attempts.length+1+'&editable=1'))+'&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate='+ (submitMCQ ? 1 : 0) +'&logbook=0&exam='+exam,
             width: "100%",
             height: "100%",
          }}
          
       handleReceiveMessage={handleMessage} />
            )}
            {(selectedContent.type === 'Exam Builder') && viewAssignment && (
                       <div  style={{height:"100%"}}><IframeComm attributes={ {src: APP_LINK+'surveygenerator/?aiEnabled='+selectedContent.aiEnabled+'&loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&attempt='+(selectedAttempt ? selectedAttempt+'&readOnly=1&editable=0' : (selectedContent.attempts.length+1+'&editable=1'))+'&type_id=13&standalone=true&pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate='+ (submitMCQ ? 1 : 0) +'&logbook=0&exam='+exam,
                       width: "100%",
                       height: "100%",
                    }}
                    
                 handleReceiveMessage={handleMessage} /><div style={{position: "absolute",top: 10,zIndex: 2030,right: 10}}>{(selectedContent.survey_exam == true || selectedContent.survey_supplementary ==true)}</div></div>
                      )}
            {(selectedContent.type === 'Exam Builder') && !viewAssignment && (
             <div  style={{height:"100%"}}><IframeComm attributes={ {src: APP_LINK+'surveygenerator/?loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&type_id=13&standalone=true&pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&attempt='+(selectedAttempt ? selectedAttempt+'&readOnly=1' : (selectedContent.attempts.length+1+'&editable=1'))+'&loc='+selectedContent.path+'&calculate='+ (submitMCQ ? 1 : 0) +'&logbook=0&exam='+exam,
             width: "100%",
             height: "100%",
          }}
          
       handleReceiveMessage={handleMessage} /><div style={{position: "absolute",top: 10,zIndex: 2030,right: 10}}>{(selectedContent.survey_exam == true || selectedContent.survey_supplementary ==true)&& <ExamTimer endTime={selectedContent.end_date}/>}</div></div>
            )}
            {(selectedContent.type === 'WSR Assessments' && submitMCQ) && (
                       <IframeComm  postMessageData={postMessageData} attributes={ {src: APP_LINK+'survey/surveyview_js.html?loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=1'+'&logbook=1&file='+logbookImage+'&exam='+exam,
                       width: "100%",
                       height: "100%",
                    }}
                    
                 handleReceiveMessage={handleMessage} />
                       )}
            {(selectedContent.type === 'Survey') && (
                       <IframeComm attributes={ {src: APP_LINK+'survey/surveyview_generator.html?loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&logbook=0&exam='+exam,
                       width: "100%",
                       height: "100%",
                    }}
                    
                 handleReceiveMessage={handleMessage} />
                      )}
            {(selectedContent.type === 'HTML Captivate' || selectedContent.type === 'HTML Articlulate') && (
                       <IframeComm attributes={ {src: getHTMLPath(selectedContent.path),
                        width: "100%",
                        height: "100%",
                    }}
                    
                 handleReceiveMessage={handleMessage} />
                        )}
            {(selectedContent.type === 'Assignments' && !submitMCQ && !viewAssignment) && (
            (<div style={{height:"100%"}}><IframeComm attributes={ {src: APP_LINK+'survey/surveyview_js.html?loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&attempt='+selectedAttempt+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0'+'&logbook=0&exam='+exam,
               width: "100%",
               height: "100%",
           }}
           
        handleReceiveMessage={handleMessage} /><div style={{position: "absolute",top: 10,zIndex: 2030,right: 10}}>{(selectedContent.survey_exam == true || selectedContent.survey_supplementary ==true)&& <ExamTimer endTime={selectedContent.end_date}/>}</div></div>)
          // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
           //  <Iframe className={classes.iframePopup} url={process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0' }/>
           )}
            {(selectedContent.type === 'Assignments' && !submitMCQ && viewAssignment && selectedContent.survey_exam === false && selectedContent.survey_supplementary ===false) && (
            (<IframeComm attributes={ {src: APP_LINK+'survey/surveyview_js.html?loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0&editable=0&attempt='+selectedAttempt+'&logbook=0&exam='+exam,
             width: "100%",
             height: "100%",
         }} 
         
         
      />)
          // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
           //  <Iframe className={classes.iframePopup} url={process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0' }/>
           )}
            {(selectedContent.type === 'Assignments' && !submitMCQ && viewAssignment && (selectedContent.survey_exam === true || selectedContent.survey_supplementary ==true)) && (
             (<IframeComm attributes={ {src: APP_LINK+'survey/surveyview_js.html?loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0&logbook=0&exam=1',
              width: "100%",
              height: "100%",
          }} 
          
          
       />)
           // SERVER_LINK+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+login.user.userId+'&loc='+selectedContent.path+'&calculate=1'
            //  <Iframe className={classes.iframePopup} url={process.env.REACT_APP_MY_VAR+'survey/surveyview_js.html?sid='+selectedContent.survey_id+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0' }/>
            )}
            {(selectedContent.type === 'WSR Assessments' && !submitMCQ && !viewAssignment) && (
             <IframeComm  attributes={ {src: APP_LINK+'survey/surveyview_js.html?loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0'+'&logbook=1&exam='+exam,
              width: "100%",
              height: "100%",
          }}
          
       handleReceiveMessage={handleMessage} />
            )}
            {(selectedContent.type === 'WSR Assessments' && !submitMCQ && viewAssignment) && (
            <IframeComm attributes={ {src: APP_LINK+'survey/surveyview_js.html?loginAs='+localStorage.getItem('loginAs')+'&adminID='+localStorage.getItem('adminID')+'&adminName='+user.user.admin+'&pid=web&sid='+selectedContent.survey_id+'&mid='+selectedContent.module_id+'&rid='+selectedContent.rid+'&uid='+user.user.userId+'&loc='+selectedContent.path+'&calculate=0&editable=0&attempt='+selectedAttempt+'&logbook=0&exam='+exam,
             width: "100%",
             height: "100%",
         }}
         
      />
           )}

            {(selectedContent.type === 'Document' && !selectedContent.pdf_collab) && (
                <IframeComm  ref={(ref) => { this.refObj[zDepth] = ref }} attributes={ {src: APP_LINK+'pdfviewer/web/viewer.html?name='+user.user.firstName+''+user.user.lastName+'&url='+selectedContent.path+'&xfdfUrl='+selectedContent.pdf_json+'&file_id='+selectedContent.file_id+'&summaryUrl='+selectedContent.pdf_summary,
                width: "100%",
                height: "100%",
             }}
             
             
          handleReceiveMessage={handlePDFTRONMessage} />
            )}
            {(selectedContent.type === 'Document' && selectedContent.pdf_collab==1) && (
             <IframeComm  ref={(ref) => { this.refObj[zDepth] = ref }} attributes={ {src: 'https://collaboration.cpslearn.co.za/?name='+user.user.firstName+' '+user.user.lastName+'&url='+selectedContent.path+'&DOCUMENT_ID='+selectedContent.rollout_id+'_'+selectedContent.contentId+'&pdf_bookmark='+STORAGE_LINK+selectedContent.bookmark_json,
             width: "100%",
             height: "100%",
          }}
       handleReceiveMessage={handlePDFTRONMessage} />
         )}
            {}
            {(selectedContent.type === 'Image' ||
              selectedContent.type === 'png' ||
              selectedContent.type === 'jpg') && (
              <img className={classes.image} src={pathToIframeFile} alt={pathToIframeFile} />
            )}
            {selectedContent.type === 'Video' && (
              <ReactPlayer
                className={classes.videoPopup}
                url={STORAGE_LINK2+pathToIframeFile}
                onPause={handlePauseVideo}
                onProgress={e => handleUpdateStatus(e)}
                onEnded={() => {
                  {
                    localStorage.getItem('loginAs') && localStorage.getItem('loginAs')==1 && localStorage.getItem('loginType')==0 ? handlePopupToggle(false, true) : saveStatus(STATUSES.completed.value);
                    addComponentStatusRequest();
                    handlePopupToggle(selectedContent, true);
                  }
                  
                }}
                controls
                playing
              />
            )}
          </div>
        </div>
        {localStorage.getItem('loginAs') && localStorage.getItem('loginAs')==1 && localStorage.getItem('loginType')==0 && !viewAssignment && (<><div style={{
        margin: 0,
        top:0,
        left:0,
        height: '100vh',
        width: '100vw',
        position: 'absolute',
        fontFamily: 'Arial, sans-serif'
      }}>

          {/* Semi-transparent overlay */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255, 255, 255, 0.3)',
            zIndex: 1
          }} />
          {/* Read-only box */}
          <div style={{
            position: 'absolute',
            top: 20,
            right: 20,
            backgroundColor: 'white',
            borderRadius: 5,
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            zIndex: 2,
            padding: '10px 15px',
            textAlign: 'center'
          }}>
            <div style={{
              fontWeight: 'bold',
              color: '#007acc',
              marginBottom: 8,
              fontSize: 14
            }}>
              Read only
            </div>
            <button
              onClick={() => this.props.handlePopupToggle(false, true)}
              style={{
                backgroundColor: '#007acc',
                color: 'white',
                border: 'none',
                padding: '6px 12px',
                borderRadius: 4,
                cursor: 'pointer'
              }}
            >
              CLOSE
            </button>
          </div>
        </div></>)}
      </div>
      </Rnd>
     
    </Popup>
  );
}
};

const styles = () => ({
  ...commonStyles,
  image: {
    margin: '0 auto',
    display: 'block',
    maxWidth: 1200,
    width: '98%',
  },
  iframeContainer: {
    backgroundColor:"#FFF",
    position: 'absolute',
    overflow: 'scroll',
    top:34,
    bottom:0,
    left:0,
    right:0
  },
  videoPopup: {
    width: '100%!important',
    height: '100%!important',
  },

  popupIframe: {
    boxShadow: '0 4px 5px 0 rgba(0,0,0,0.24)',
    width: '100%',
    height: '100%',
    position: 'relative',
    zIndex: 10,
  },
  popupHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems:'center',
    backgroundColor:COLORS.yellow
  },
  closePopup: {
    color: '#fff',
    background: 'transparent',
    alignSelf: 'flex-end',
    cursor: 'pointer',
    margin: '10px 5px 0 0',
  },
});
const mapDispatchToProps = dispatch => ({
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  setMediaType: surveyId => dispatch(setMediaType(surveyId)),
  addComponentStatusRequest: () => dispatch(addComponentStatusRequest()),
  saveStatus: status => dispatch(saveStatus(status)),
  setCost: status => dispatch(setCost(status)),
  assignmentRequestRequest: type => dispatch(assignmentRequestRequest(type)),
  selectAnnotationSave: json => dispatch(selectAnnotationSave(json)),
  selectBookmarksSave: json => dispatch(selectBookmarksSave(json)),
  saveAnnotationRequest: () => dispatch(saveAnnotationRequest()),
  saveBookmarksRequest: () => dispatch(saveBookmarksRequest()),
  setDeleteIndex: (int) => dispatch(setDeleteIndex(int)),
  selectRollout: (int) => dispatch(selectRollout(int)),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
  setPopups: array => dispatch(setPopUps(array)),
  selectAttempt: moduleId => dispatch(selectAttempt(moduleId)),
  getUserComponent:() => dispatch(contentItemRequest()),
  selectUserContent: contentId => dispatch(selectUserContent(contentId)),
  selectUserModule: contentId => dispatch(selectUserModule(contentId)),
  selectAssessmentContent: obj => dispatch(selectAssessmentContent(obj)),
  toggleExamComplete:bool => dispatch(toggleExamComplete(bool)),
  submitMCQRequest: value => dispatch(submitMCQ(value)),
  showSaveModal:bool => dispatch(showSaveModal(bool)),
  selectItem:bool => dispatch(selectItem(bool)),
});

const mapStateToProps = state => ({
  user: state.loginReducer,
  programsFull: state.userProgramsFullReducer,
  submitMCQ: state.userProgramsFullReducer.submitMCQ,
  selectedAttempt: state.userProgramsFullReducer.selectedAttempt,
  viewAssignment: state.userProgramsFullReducer.viewAssignment,
  logbookImage: state.userProgramsFullReducer.logbookImage,
  popups:state.viewReducer.popups,
  view: state.viewReducer,
  examComplete: state.userProgramsFullReducer.examComplete,
  assessmentContent: state.userProgramsFullReducer.assessmentContent
});
export default compose(
  withState('statusComponent', 'handleChangeStatus', 0),
  withState('startTimePdf', 'handleSpentTimePdf', 0),
  withState('minimized', 'toggleMinimize', false),
  withState('isDragged', 'isDraggedToggle', false),
  withState('isMobile', 'setIsMobile', false),
  withState('currentWidth', 'changeWidth', '100%'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handlePopupToggle: props => (item, closed, video) => {
      const { isShowPopup, xapiRequest, getUserComponent, selectedContent, selectedContent: { type: contentType  }, saveTimeTaken, addComponentStatusRequest, selectAttempt }= props;



      //xapiRequest({ xapiType: `${xapiType}`});
      if (isShowPopup) {
        props.selectItem(selectedContent)
      }

      if (
        saveStatus &&
        (contentType === 'Image' ||
          contentType === 'jpg' ||
          contentType === 'png' ||
          contentType === 'Document' ||
          contentType === 'HTML Captivate' ||
          contentType === 'HTML Articlulate')
      ) {
        props.showSaveModal(true)
      }
      if ((contentType!='Assignments' && contentType!='Survey' && contentType!='Webinar' && contentType!='WSR Assessments') || (video==true && contentType=='Webinar')) {
      //   saveStatus(STATUSES.completed.value);
      //  // saveTimeTaken(Math.round((Date.now() - startTimePdf) / 1000));
      //   addComponentStatusRequest();
      }else{
        //getUserComponent();
      }
      if(closed==true){
        var itemToRemove
        var tmp = props.popups;
        tmp.splice(props.view.windowDeleteIndex,1)
        props.setPopups(tmp);
        selectAttempt(null);
        //}

        //props.togglePopup(!isShowPopup);
      }else{
        
        var tmp = props.popups;
        tmp.push(item);
        props.setPopups(tmp);
        //props.togglePopup(!isShowPopup);

      }
    },
  }),
  withHandlers({
    
    handleAssignmentStatus: props => e => {
      const {
        addComponentStatus,
        selectedContentItem,
        addComponentStatusRequest,
        saveStatus,
        saveTimeTaken
      } = props;
      
      if(e=='in progress' && selectedContentItem.status != 'in progress'){
        saveStatus(STATUSES.inProgress.value);

        addComponentStatusRequest();
      }

      
      if(e==='ready' && selectedContentItem.status != 'ready'){
        
        saveStatus(STATUSES.ready.value);
        addComponentStatusRequest();
      }

      if(e==='submitted' && selectedContentItem.status != 'submitted'){
        
        saveStatus(STATUSES.submitted.value);
        addComponentStatusRequest();
      }
      if(e==='not started' && selectedContentItem.status != 'not started'){
        
        saveStatus(STATUSES.notStarted.value);
        addComponentStatusRequest();
      }
      if(e==='completed' && selectedContentItem.status != 'completed'){
        
        saveStatus(STATUSES.completed.value);
        addComponentStatusRequest();
      }
      if(e==='marking' && selectedContentItem.status != 'marking'){
        
        saveStatus(STATUSES.marking.value);
        addComponentStatusRequest();
      }

    },
    handlePauseVideo: props => () => {
      const { xapiRequest, selectedContent: item } = props;
      xapiRequest({ xapiType: `Paused${item.type}`, item });
    },
    handleUpdateStatus: props => e => {
      const { selectedContent, saveStatus, saveTimeTaken } = props;
      
      if (selectedContent.status !== STATUSES.completed.value) {
        saveStatus(STATUSES.inProgress.value);
      }
     // saveTimeTaken(Math.round(e.playedSeconds / 1000));
    },
    getHTMLPath: props => path => {
      var p = path.split('.zip')
      return p[0]+'/index.html'
    },
    onDragStop: props => e => {
      e.stopImmediatePropagation()
    },
    onDrag: props => e => {
      if(e.offset<0){
        props.isDraggedToggle({xPos:e.x-e.offsetX,yPos:e.y-e.offsetY})
      }else{
        props.isDraggedToggle({xPos:e.x-e.offsetX,yPos:e.y-76})
      }
      e.stopImmediatePropagation()
    },
    onDragStart: props => e => {
      e.stopImmediatePropagation()
    },
    handlePDFTRONMessage: props => e => {
      try {
        var obj = JSON.parse(e.data)

        props.selectUserModule(props.selectedContent.module_id)
        props.selectRollout(props.selectedContent.rollout_id);
        console.log('msg 2', obj)
        if(obj.action=='Save Annotations'){
          props.selectAnnotationSave(JSON.stringify(obj.payload))
          props.selectUserContent(props.selectedContent.contentId);
          props.selectBookmarksSave(obj.bookmarks)
          //props.saveBookmarksRequest();
          props.saveAnnotationRequest();
          props.handlePopupToggle(props.selectedContent, true, props.zDepth);
        }
        if(obj.action=='Save Bookmarks'){
          props.selectBookmarksSave(obj.bookmarks)
          props.selectUserContent(props.selectedContent.contentId);
          props.saveBookmarksRequest();
          props.handlePopupToggle(props.selectedContent, true, props.zDepth);
        }
      } catch (error) {}
    },
    handlePDFTRONSENDMessage: props => (e, p) => {
      if(!props.selectedContent.pdf_collab|| props.selectedContent.pdf_collab==0){
        props.selectUserModule(props.selectedContent.module_id)
        props.selectRollout(props.selectedContent.rollout_id);
        props.setDeleteIndex(props.zDepth)
        p.refObj[props.zDepth].sendMessage('save', "*")
      }else{
        props.selectUserModule(props.selectedContent.module_id)
        props.selectRollout(props.selectedContent.rollout_id);
        props.setDeleteIndex(props.zDepth)
        p.refObj[props.zDepth].sendMessage('save', "*")
      }
     
    },
    handleMinimize: props => e => {
      
      props.toggleMinimize(!props.minimized)
    },
    handleMessage: props => e => {
      const { addComponentStatusRequest, saveStatus, setCost, selectUserModule, saveTimeTaken, handleAssignmentStatus, setMediaType, selectedContent, selectRollout, submitMCQ, assignmentRequestRequest, selectAssessent, selectAssessmentContent } = props;
      try {
        var msg = JSON.parse(e.data);
        console.log('msg 1', msg)
        // Add catch-all for PDF annotations
        if(msg.action === 'Save Annotations'){
          props.selectAnnotationSave(JSON.stringify(msg.payload))
          props.selectUserContent(props.selectedContent.contentId);
          props.selectBookmarksSave(msg.bookmarks)
          props.saveAnnotationRequest();
          props.handlePopupToggle(props.selectedContent, true, props.zDepth);
          return;
        }

        if(msg.action==='STATUS'){
          selectUserModule(selectedContent.module_id)
          selectRollout(selectedContent.rollout_id);
          if(msg.status==='ready' && selectedContent.status !== 'ready'){
            handleAssignmentStatus(msg.status);
          }else if(msg.status==='completed' && selectedContent.status !== 'completed' && selectedContent.survey_exam==false && selectedContent.survey_supplementary==false){
            if(msg?.result?.passed=='NYC'){
              if(selectedContent.attempts.length==0){
                if(submitMCQ==true){
                  selectAssessment(selectedContent.survey_id);
                  selectAssessmentContent(selectedContent);
                  selectUserModule(selectedContent.module_id)
                  selectRollout(selectedContent.rollout_id);
                  setCost(selectedContent.survey_cost);
                  setMediaType('document');
                  assignmentRequestRequest('retake');
                  saveStatus(STATUSES.notStarted.value);
                  addComponentStatusRequest();
                }
              }else{
                handleAssignmentStatus('submitted');
              }
            }else{
              selectUserModule(selectedContent.module_id)
              selectRollout(selectedContent.rollout_id);
              handleAssignmentStatus(msg.status);
            }
          }else if(msg.status==='in progress' && (selectedContent.status !== 'in progress' || selectedContent.status !== 'ready')){
            selectUserModule(selectedContent.module_id)
            selectRollout(selectedContent.rollout_id);
            handleAssignmentStatus(msg.status);
          }else if(msg.status==='marking' && (selectedContent.status !== 'marking')){
            handleAssignmentStatus(msg.status);
          }else if(msg.status==='completed' && (selectedContent.status !== 'marking')){
            handleAssignmentStatus(msg.status);
          }
        }else if(msg.status==='completed' && (selectedContent.status !== 'marking')){
          handleAssignmentStatus(msg.status);
        }else if(msg.status==='in progress' && (selectedContent.status !== 'in progress' || selectedContent.status !== 'ready')){
          handleAssignmentStatus(msg.status);
        }else if(selectedContent.type === 'HTML Captivate' || selectedContent.type === 'HTML Articlulate'){
          saveStatus(STATUSES.completed.value);
        }
      } catch (error) {}
    },
  }),
  
 
  lifecycle({
    componentDidMount() {
      const {
        contentIframe,
        saveTimeTaken,
        saveStatus,
        addComponentStatusRequest,
        handleSpentTimePdf,
        selectedContent
      } = this.props;
      if (contentIframe) {
        saveTimeTaken(0);
      }
      this.props.selectItem(selectedContent)
      this.props.xapiRequest({ xapiType: `Opened`})
      let elem =  document.querySelector('#popup-container')
      let rect = elem.getBoundingClientRect();
 if(rect.width>724){
   this.props.setIsMobile(true)
 }
    },
    componentWillReceiveProps(nextProps) {
      const { addComponentStatus: thisAddComponentStatus, handlePopupToggle, zDepth, setDeleteIndex, assessmentContent } = this.props;
      const { addComponentStatus: nextAddComponentStatus, handleChangeStatus, status } = nextProps;
 
      if (this.props.examComplete==false && nextProps.examComplete==true) {
        this.props.submitMCQRequest(true);
        this.props.selectAssessmentContent(assessmentContent)
        this.props.selectUserContent(assessmentContent.contentId);
        this.props.selectAssessment(assessmentContent.survey_id);

        handlePopupToggle(assessmentContent);
      }
    },
    componentWillUnmount() {
      const {
        selectedContent: { type: contentType },
        contentIframe,
        saveStatus,
        saveTimeTaken,
        addComponentStatusRequest,
        startTimePdf,
      } = this.props;
      if (
        saveStatus &&
        (contentType === 'Image' ||
          contentType === 'jpg' ||
          contentType === 'png' ||
          contentType === 'Document' ||
          contentType === 'HTML Captivate' ||
          contentType === 'HTML Articlulate' ||
          contentType === 'Video')
      ) {}
      this.props.xapiRequest({ xapiType: `Closed`})
      if (contentIframe && contentType!='Assignments' && contentType!='Survey') {
        
        saveTimeTaken(Math.round((Date.now() - startTimePdf) / 1000));
        //addComponentStatusRequest();
      }
    },
  }),
  withStyles(styles),
)(ZoomPopup);

ZoomPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  selectedContent: PropTypes.instanceOf(Object),
  handlePopupToggle: PropTypes.func,
  handlePauseVideo: PropTypes.func,
  handleUpdateStatus: PropTypes.func,
  saveStatus: PropTypes.func,
};
